<app-bannerregistrados></app-bannerregistrados>


<!---->
<div>
  <div class="contenedorMain">
    <div class="contenedorChild">

      <div class="contenedorChildTwo">
      
        <div class="col1">
          <h2 class="titleInterno ">

            <svg width="35" height="35" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M15.9908 18.3333H6.00926C5.72876 18.3333 5.50051 18.1279 5.50051 17.8749V4.12492C5.50051 3.87192 5.72876 3.66659 6.00926 3.66659H10.0838V7.47075C10.0838 8.91175 11.1994 10.0833 12.5717 10.0833H16.5005V17.8749C16.5005 18.1279 16.2713 18.3333 15.9908 18.3333ZM16.1788 8.24992H12.5717C12.2105 8.24992 11.9172 7.90067 11.9172 7.47075V3.66659H12.0198L16.1788 8.24992ZM18.0955 7.63392L13.1052 2.13392C12.9319 1.94234 12.6853 1.83325 12.4259 1.83325H6.00926C4.71768 1.83325 3.66718 2.86175 3.66718 4.12492V17.8749C3.66718 19.1381 4.71768 20.1666 6.00926 20.1666H15.9908C17.2824 20.1666 18.3338 19.1381 18.3338 17.8749V8.24992C18.3338 8.02167 18.2486 7.80259 18.0955 7.63392Z"
                fill="#DA291C" />
            </svg>
            Registrados
          </h2> 
          
        </div>
        <div class="col2">
          <input type="text" class="inputCombo" placeholder="Ingresar valor a filtrar" [(ngModel)]="filtro"
            (keyup.enter)="ListaURL_Creadas()" style="text-align: center;" >

        </div>
        <div class="col3">
          <p><b>Se han registrado {{cantidad}} codigos</b></p>
        </div>
      </div>
     <div class="tableMain">

     
        <table class="table table-responsive">
          <thead>
            <tr class="table-secondary" style="border-radius: 50">
              <th scope="col" style="text-align: center;">#</th>
              <th scope="col" style="text-align: left;">Codigo</th>
              <th scope="col" style="text-align: center;width: 1216px;">URL</th>
              <th scope="col" style="text-align: center;">Fecha de Creación</th>
              <th scope="col" style="text-align: center;" *ngIf="esAdministrado">Creador</th>
              <th scope="col" style="text-align: center;">Estado</th>
              <th scope="col" style="text-align: center;">Estadistica</th>
              <th scope="col">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let result of QR_List_List | paginate: { itemsPerPage: 10, currentPage: p }">
              <td scope="row" [class.disabled]="{true: result.estado === 'Activo' ? false : 'red'}">
                {{result.id_qr}}</td>
              <td>
                <button type="button" class="btn btn-secondary" style="margin-left: 5px;" data-bs-toggle="modal"
                  data-bs-target="#exampleModal" (click)="generarQRCode(result.url_qr_redirec + result.id_qr, result)"
                  [disabled]="result.estado !== 'Activo'">
                  <i class="bi bi-qr-code"></i>
                </button>
              </td>
              <td style="text-align: left;">{{result.url_qr}}</td>
              <td style="text-align: center;">{{ result.fecha_creacion | date:'dd/MM/yyyy' }}</td>
              <td style="text-align: center;" *ngIf="esAdministrado">
                {{ result.user }}
              </td>
              
              <td style="text-align: center;">
                <!--
                      <i class="bi bi-circle-fill" [ngClass]="{'small-icon': true}"
                        [ngStyle]="{color: result.estado === 'Activo' ? 'green' : 'red'}" style="padding-right: 10px;">
                      </i>{{result.estado}}-->


                <input type="checkbox" class="switchInput" id="switch-{{result.id_qr}}" [(ngModel)]="result.estado_bool"
                  (click)="desactivarURL(result.id_qr, result.estado_bool)" />
                <label class="switchLabel" for="switch-{{result.id_qr}}">Toggle</label>
              </td>
              <td>
                <button type="button" class="btn btn-success" (click)="ReporteDetallado(result.id_qr)"
                  [disabled]="result.estado !== 'Activo'">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M16.3335 3.83325C15.8752 3.83325 15.5002 4.20825 15.5002 4.66659V17.1666C15.5002 17.6249 15.8752 17.9999 16.3335 17.9999C16.7918 17.9999 17.1668 17.6249 17.1668 17.1666V4.66659C17.1668 4.20825 16.7918 3.83325 16.3335 3.83325ZM10.5002 7.16659C10.0418 7.16659 9.66683 7.54159 9.66683 7.99992V17.1666C9.66683 17.6249 10.0418 17.9999 10.5002 17.9999C10.9585 17.9999 11.3335 17.6249 11.3335 17.1666V7.99992C11.3335 7.54159 10.9585 7.16659 10.5002 7.16659ZM3.8335 11.3333C3.8335 10.8749 4.2085 10.4999 4.66683 10.4999C5.12516 10.4999 5.50016 10.8749 5.50016 11.3333V17.1666C5.50016 17.6249 5.12516 17.9999 4.66683 17.9999C4.2085 17.9999 3.8335 17.6249 3.8335 17.1666V11.3333Z"
                      fill="#17798C" />
                    <mask id="mask0_142_5679" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="3"
                      width="15" height="15">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M16.3335 3.83325C15.8752 3.83325 15.5002 4.20825 15.5002 4.66659V17.1666C15.5002 17.6249 15.8752 17.9999 16.3335 17.9999C16.7918 17.9999 17.1668 17.6249 17.1668 17.1666V4.66659C17.1668 4.20825 16.7918 3.83325 16.3335 3.83325ZM10.5002 7.16659C10.0418 7.16659 9.66683 7.54159 9.66683 7.99992V17.1666C9.66683 17.6249 10.0418 17.9999 10.5002 17.9999C10.9585 17.9999 11.3335 17.6249 11.3335 17.1666V7.99992C11.3335 7.54159 10.9585 7.16659 10.5002 7.16659ZM3.8335 11.3333C3.8335 10.8749 4.2085 10.4999 4.66683 10.4999C5.12516 10.4999 5.50016 10.8749 5.50016 11.3333V17.1666C5.50016 17.6249 5.12516 17.9999 4.66683 17.9999C4.2085 17.9999 3.8335 17.6249 3.8335 17.1666V11.3333Z"
                        fill="white" />
                    </mask>
                    <g mask="url(#mask0_142_5679)">
                      <rect x="0.5" y="0.5" width="20" height="20" fill="#17798C" />
                    </g>
                  </svg>
                </button>
              </td>
              <td>
                <button type="button" class="btn btn-secondary" style="margin-left: 5px;" data-bs-toggle="modal"
                  data-bs-target="#exampleModalEditar" (click)="abrirEdicionURL(result)"
                  [disabled]="result.estado !== 'Activo'" title="Editar URL">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button type="button" class="btn btn-danger" style="margin-left: 5px;" data-bs-toggle="modal"
                  data-bs-target="#exampleModal2" (click)="obtenerIdEliminacion(result)"
                  [disabled]="result.estado !== 'Activo'">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.83317 13.8334C8.83317 14.2917 8.45817 14.6667 7.99984 14.6667C7.5415 14.6667 7.1665 14.2917 7.1665 13.8334V10.5001C7.1665 10.0417 7.5415 9.66675 7.99984 9.66675C8.45817 9.66675 8.83317 10.0417 8.83317 10.5001V13.8334ZM13.8332 13.8334C13.8332 14.2917 13.4582 14.6667 12.9998 14.6667C12.5415 14.6667 12.1665 14.2917 12.1665 13.8334V10.5001C12.1665 10.0417 12.5415 9.66675 12.9998 9.66675C13.4582 9.66675 13.8332 10.0417 13.8332 10.5001V13.8334ZM15.4998 16.3334C15.4998 16.7926 15.1265 17.1667 14.6665 17.1667H6.33317C5.87317 17.1667 5.49984 16.7926 5.49984 16.3334V7.16675H15.4998V16.3334ZM8.83317 4.10675C8.83317 3.97758 9.0115 3.83341 9.24984 3.83341H11.7498C11.9882 3.83341 12.1665 3.97758 12.1665 4.10675V5.50008H8.83317V4.10675ZM17.9998 5.50008H17.1665H13.8332V4.10675C13.8332 3.03675 12.899 2.16675 11.7498 2.16675H9.24984C8.10067 2.16675 7.1665 3.03675 7.1665 4.10675V5.50008H3.83317H2.99984C2.5415 5.50008 2.1665 5.87508 2.1665 6.33342C2.1665 6.79175 2.5415 7.16675 2.99984 7.16675H3.83317V16.3334C3.83317 17.7117 4.95484 18.8334 6.33317 18.8334H14.6665C16.0448 18.8334 17.1665 17.7117 17.1665 16.3334V7.16675H17.9998C18.4582 7.16675 18.8332 6.79175 18.8332 6.33342C18.8332 5.87508 18.4582 5.50008 17.9998 5.50008Z"
                      fill="#DA291C" />
                    <mask id="mask0_142_5672" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="2"
                      width="17" height="17">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M8.83317 13.8334C8.83317 14.2917 8.45817 14.6667 7.99984 14.6667C7.5415 14.6667 7.1665 14.2917 7.1665 13.8334V10.5001C7.1665 10.0417 7.5415 9.66675 7.99984 9.66675C8.45817 9.66675 8.83317 10.0417 8.83317 10.5001V13.8334ZM13.8332 13.8334C13.8332 14.2917 13.4582 14.6667 12.9998 14.6667C12.5415 14.6667 12.1665 14.2917 12.1665 13.8334V10.5001C12.1665 10.0417 12.5415 9.66675 12.9998 9.66675C13.4582 9.66675 13.8332 10.0417 13.8332 10.5001V13.8334ZM15.4998 16.3334C15.4998 16.7926 15.1265 17.1667 14.6665 17.1667H6.33317C5.87317 17.1667 5.49984 16.7926 5.49984 16.3334V7.16675H15.4998V16.3334ZM8.83317 4.10675C8.83317 3.97758 9.0115 3.83341 9.24984 3.83341H11.7498C11.9882 3.83341 12.1665 3.97758 12.1665 4.10675V5.50008H8.83317V4.10675ZM17.9998 5.50008H17.1665H13.8332V4.10675C13.8332 3.03675 12.899 2.16675 11.7498 2.16675H9.24984C8.10067 2.16675 7.1665 3.03675 7.1665 4.10675V5.50008H3.83317H2.99984C2.5415 5.50008 2.1665 5.87508 2.1665 6.33342C2.1665 6.79175 2.5415 7.16675 2.99984 7.16675H3.83317V16.3334C3.83317 17.7117 4.95484 18.8334 6.33317 18.8334H14.6665C16.0448 18.8334 17.1665 17.7117 17.1665 16.3334V7.16675H17.9998C18.4582 7.16675 18.8332 6.79175 18.8332 6.33342C18.8332 5.87508 18.4582 5.50008 17.9998 5.50008Z"
                        fill="white" />
                    </mask>
                    <g mask="url(#mask0_142_5672)">
                      <rect x="0.5" y="0.5" width="20" height="20" fill="#DA291C" />
                    </g>
                  </svg>

                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls (pageChange)="p = $event"></pagination-controls>

      <!--
              <div class="d-flex justify-content-center">
                <pagination-controls (pageChange)="pageChanged($event)" id="server"></pagination-controls>
              </div>

              <br>
-->


      <!--
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button class="btn btn-primary" hreff="urlQR" >Ir al Link</button>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div>
                <p><b>Codigo</b> QR# {{nroQR}}</p>
                <p><b>Creado:</b> {{fechaCreacionQR| date:'dd/MM/yyyy'}}</p>
                <p><b>Estado:</b> {{estadoQR}}</p>
              </div>
              <div style="text-align: center;">
                <qrcode (qrCodeURL)="onChangeURL($event)" [qrdata]="myAngularxQrCode" [width]="256"
                  [errorCorrectionLevel]="'M'" logo="../assets/img/Movil.png"></qrcode>
                <div>
                  <button (click)="downloadQRCode('png')" class="descargar2">Download as PNG</button>
                  <button (click)="downloadQRCode('jpeg')" class="descargar2">Download as JPEG</button>
                  <button (click)="downloadQRCode('svg')" class="descargar2">Download as SVG</button>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
          </div>
        </div>
      </div>
    -->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <!-- Este modal usa un layout de 2 paneles sin barra de header
                 (a diferencia de #exampleModal2/#exampleModalEditar), así
                 que el botón de cerrar flota sobre la esquina en vez de ir
                 dentro de un .modal-header. Antes no tenía ninguno: solo se
                 podía cerrar clickeando el fondo oscuro o con Escape. -->
            <button type="button" class="btn-close btnCerrarVerQR" data-bs-dismiss="modal" aria-label="Close"></button>
            <div class="modal-body">
              <div class="qr-code-container">
                <!-- *ngIf: el modal queda en el DOM (oculto) desde que carga la pantalla;
                     sin esto, angularx-qrcode tira console.error por qrdata vacío antes de
                     que el usuario abra el modal por primera vez. -->
                <qrcode *ngIf="myAngularxQrCode" (qrCodeURL)="onChangeURL($event)" [qrdata]="myAngularxQrCode" [width]="240"
                  [colorDark]="modalQrColor" [imageSrc]="modalQrLogoSrc" [imageHeight]="modalQrLogoSize" [imageWidth]="modalQrLogoSize"
                  [errorCorrectionLevel]="nivelCorreccionModal"></qrcode>
              </div>
              <div class="qr-details">
                <h2 class="titleCode">Código QR #{{nroQR}}</h2>
                <p class="parrafoCode"><span>Creado:</span> {{fechaCreacionQR| date:'dd/MM/yyyy'}}</p>
                <p class="parrafoCode"><span>Estado:</span> {{estadoQR}}</p>

                <div class="personalizarQRModal">
                  <p class="parrafoCode">Personalizar:</p>
                  <label class="subLabel">Color del código</label>
                  <div class="colorRow">
                    <input type="color" class="colorPicker" [(ngModel)]="modalQrColor" title="Elegir color personalizado">
                    <button type="button" class="colorSwatch" *ngFor="let color of coloresPreset"
                            [style.background-color]="color"
                            [class.colorSwatchActive]="color === modalQrColor"
                            (click)="seleccionarColorModal(color)"
                            [attr.aria-label]="'Usar color ' + color">
                    </button>
                  </div>

                  <label class="subLabel" style="margin-top: 10px; display: block;">Ícono al centro (opcional)</label>
                  <div class="colorRow">
                    <input type="file" accept="image/*" #logoInputModal class="inputArchivo" (change)="onLogoSeleccionadoModal($event)">
                    <button type="button" class="descargar2" *ngIf="modalQrLogoSrc" (click)="quitarIconoModal(logoInputModal)">Quitar</button>
                  </div>

                  <button type="button" class="descargar2 btnGuardarPersonalizacion" (click)="guardarPersonalizacionRegistrado()">
                    Guardar personalización
                  </button>
                </div>

                <div class="botones">
                  <p class="parrafoCode">Descargar en los diferentes formatos:</p>
                  <button (click)="downloadQRCode('png')" class="btn btn-success" style="margin-right: 10px;">
                    PNG</button>
                  <button (click)="downloadQRCode('jpeg')" class="btn btn-success" style="margin-right: 10px;">
                    JPEG</button>
                  <button (click)="downloadQRCode('svg')" class="btn btn-success"> SVG</button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!--ELIMINAR-->

      <div id="modal" class="modal">
        <div class="modal-content">
          <span class="close" onclick="toggleModal()">&times;</span>
          <h2>Este es un modal</h2>
          <p>Contenido del modal. Puedes poner lo que quieras aquí.</p>
          <button onclick="toggleModal()">Cerrar</button>
        </div>
      </div>

      <script>
        function toggleModal() {
          var modal = document.getElementById("modal");
          modal.style.display = (modal.style.display === "flex") ? "none" : "flex";
        }
      </script>

      <div class="modal fade" id="exampleModal2" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content modalEliminarMain">
            <div class="modal-header">

              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body modalEliminar">

              <h4 class="titleModal">¿Está seguro de eliminar el código QR?</h4>
              <p class="parrafoModal">Esta acción es totalmente irreversible y no se podrá recuperar.</p>
            </div>
            <div style="text-align: center;">
              <button type="button" class="btn btn-danger eliminar" data-bs-dismiss="modal"
                (click)="eliminarURL()">Eliminar</button>
            </div>
            <br>

          </div>
        </div>
      </div>

      <!--EDITAR URL-->
      <div class="modal fade" id="exampleModalEditar" tabindex="-1" aria-labelledby="exampleModalLabelEditar" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content modalEliminarMain">
            <div class="modal-header">
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body modalEliminar">
              <h4 class="titleModal">Editar URL del código QR #{{idQrEdicion}}</h4>
              <p class="parrafoModal">Cambia el contenido al que apunta este código. El diseño del QR no cambia.</p>
              <input type="text" class="inputCombo" style="width: 100%; margin-top: 15px;"
                [(ngModel)]="urlEdicionValue" placeholder="https://...">
            </div>
            <div style="text-align: center;">
              <button type="button" class="registrar" data-bs-dismiss="modal"
                (click)="guardarEdicionURL()">Guardar cambios</button>
            </div>
            <br>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>
<app-footer></app-footer>
<app-loading *ngIf="loading$ | async"></app-loading>